var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45042 27.4503H4.90037V32.3502V44.6001C4.90037 47.3024 7.09798 49.5 9.80028 49.5H39.1997C41.902 49.5 44.0996 47.3024 44.0996 44.6001V32.3502V27.4503H46.5496C47.5394 27.4503 48.4361 26.8525 48.8133 25.9386C49.1931 25.0224 48.9824 23.9689 48.2817 23.2682L26.2321 1.21845C25.2742 0.260515 23.7258 0.260515 22.7679 1.21845L0.7183 23.2682C0.0176133 23.9689 -0.193083 25.0224 0.18666 25.9386C0.563953 26.8525 1.46064 27.4503 2.45042 27.4503ZM24.5 6.41484L39.1997 21.1147V32.3502L39.2022 44.6001H9.80028V32.3502V25.0003V21.1147L24.5 6.41484Z",
    fill: "#C10037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4975 39.5186C33.322 39.5186 36.177 31.3341 36.2938 30.9872L31.7659 29.551C31.7468 29.6042 29.9047 34.8933 24.4975 34.8933C19.1641 34.8933 17.3005 29.7568 17.2267 29.5371L12.7012 30.9872C12.8179 31.3341 15.6729 39.5186 24.4975 39.5186Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUs2);
export default __webpack_public_path__ + "static/media/why-us-2.a925452276eeb213f27ccde674391736.svg";
export { ForwardRef as ReactComponent };